/**
 * LLM-facing parameter schema for TransformDatasetTool.
 */
import type z from 'zod';

import { pipelineSchema } from '#plugin-chat/lib/data-pipeline/engine/pipeline-schema.ts';
import { inputDatasetSchema, outputDatasetSchema } from '#plugin-chat/lib/tool/dataset-keys.ts';

/**
 * Static input schema for the transformDataset tool.
 *
 * Extends the canonical `pipelineSchema` with tool-layer fields:
 * - `inputDataset` — key of the upstream dataset in the chat-history store
 * - `outputDataset` — key to stage the processed result under
 */
export const TransformDatasetInputSchema = pipelineSchema.extend({
  inputDataset: inputDatasetSchema,
  outputDataset: outputDatasetSchema,
});

/** @public */
export type TransformDatasetInput = z.infer<typeof TransformDatasetInputSchema>;
